import type { App } from 'vue'
import { registerStore, storeInstance } from '@/store'

export default {
  install: (app: App<Element>) => {
    app.use(storeInstance)
    const store = registerStore()
    app.config.globalProperties.$store = store
  },
}
